import { ParsedUrlQuery } from 'querystring';

const handleQueryPageNumbers = (query: ParsedUrlQuery, page: number) => {
    if (page > 1) {
        return {
            ...query,
            pn: page.toString()
        };
    }

    const { pn, ...rest } = query;
    return rest;
};

const getQueryWithEncodedLocation = (query: ParsedUrlQuery) => {
    const { q: location } = query;

    if (location) {
        return {
            ...query,
            q: encodeURIComponent(location as string)
        };
    }

    return query;
};

// Temporary fixes below. This should be removed in favour of logic used in 'updateResults'
// so all page nav is handled by the same function.
export const buildQueryParamsString = (
    query: ParsedUrlQuery,
    page: number
): string => {
    const queryWithHandledPageNumbers = handleQueryPageNumbers(query, page);
    const queryWithEncodedLocation = getQueryWithEncodedLocation(
        queryWithHandledPageNumbers
    );

    return `${Object.entries(queryWithEncodedLocation)
        .map(([key, value]) => {
            // Temporary fix.
            if (key === 'feature' && Array.isArray(value)) {
                const string = value.map((featureValue: string) => {
                    return `feature=${featureValue}`;
                });

                return string.join('&');
            }

            return key + '=' + queryWithEncodedLocation[key];
        })
        .join('&')}`;
};

export const buildUrlFromPathAndQueryParams = (
    path: string | undefined,
    queryParameters: string
) => {
    const shouldShowForwardSlash = path && path[path.length - 1] !== '/';
    const pathAndParamsJoiner = shouldShowForwardSlash ? '/' : '';

    return `${path}${pathAndParamsJoiner}?${queryParameters}`;
};
